import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const trustItems = [
    {
      icon: 'ri-refresh-line',
      title: t('trust_1_title'),
      desc: t('trust_1_desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('trust_2_title'),
      desc: t('trust_2_desc'),
    },
    {
      icon: 'ri-scales-3-line',
      title: t('trust_3_title'),
      desc: t('trust_3_desc'),
    },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14 md:mb-16">
          <span className="text-xs font-label font-semibold tracking-widest uppercase text-foreground-400 mb-4 block">
            {t('trust_label')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl">
            {t('trust_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {trustItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-2xl p-8 md:p-10 hover:bg-background-200/70 transition-colors duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${item.icon} text-3xl text-foreground-800 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}